export default __webpack_public_path__ + "static/media/mercury.77316c95.png";